import {
  Button,
  Form,
  Layout,
  Space,
  Spin,
  Steps,
  Typography,
  message
} from "antd";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import APIService from "../Api/api.service";
import Authorization from "../components/FMLA/authorization";
import Document from "../components/FMLA/documents";
import Facility from "../components/FMLA/facility";
import PatientInformation from "../components/FMLA/patientinformation";
import Recipient from "../components/FMLA/recipient";
import Requester from "../components/FMLA/requester";
import { ThemeContext } from "../context/themeContext";
import { dataDate } from "../components/dateValidator";
import CustomHeader from "../components/common/Header";


const FormItemLayout = {
  labelCol: {
    xl: {
      span: 24,
    },
  },
  wrapperCol: {
    xl: {
      span: 24,
    },
  },
};
const PatientdetailsFMLA = () => {
  const { theme } = useContext(ThemeContext)
  const navigate = useNavigate(); // Hook for navigation
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [apiservice] = useState(() => new APIService());
  const { Content, Footer, Header } = Layout;
  const [form] = Form.useForm();
  const [defaultFile, setDefaultFile] = useState({})

  const [patientDetailsFMLA, setpatientDetails] = useState({
    IsPatient: "",
    AssociatedWithPatient: "",
    IsPatientMinor: "",
    PFirstName: "",
    PLastName: "",
    PatientPhoneNumber: "",
    PDOB: "",
    PEmail: "",
    PAddLine1: "",
    PAddLine2: "",
    PCity: "",
    PState: "",
    PZipCode: "",
    RequesterFName: "",
    RequesterLName: "",
    RequesterPhoneNumber: "",
    RequesterEmail: "",
    RequesterAddLine1: "",
    RequesterAddLine2: "",
    RequesterCity: "",
    RequesterState: "",
    RequesterZipCode: "",
    FacilityStartDate: "",
    FacilityEndDate: "",
    ffacilityname: "",
    FphysicianName: "",
    FacilityEmail: "",
    FacilityPhoneNumber: "",
    FacilityAddressLine1: "",
    FacilityAddressLine2: "",
    FacilityCity: "",
    FacilityState: "",
    FacilityZipCode: "",
    RecipientDiscloseRecordsTo: "",
    RecipientMethodOfRelease: "",
    RecipientName: "",
    RecipientEmail: "",
    RecipientVerifyEmail: "",
    RecipientFax: "",
    RecipientPhoneNumber: "",
    Authorizationsignature: "",
    Authorization1: "",
    Authorization2: "",
    Authorization3: "",
    Authorization4: "",
    DocumentHIPPAAuthorization: [],
    DocumentFMLAForm: [],
    DocumentAdditionalDoc: [],
    DocumentAdditionalNotes: "",
    recordsDisclose: ''
  });
  const onsubmit = async () => {
    form
      .validateFields()
      .then(async () => {
        setLoading(true);
        if (patientDetailsFMLA.IsPatient.toString().toLowerCase() == "yes") {
          patientDetailsFMLA.RequesterFName = patientDetailsFMLA.PFirstName.toString();
          patientDetailsFMLA.RequesterLName = patientDetailsFMLA.PLastName.toString();
          patientDetailsFMLA.RequesterPhoneNumber = patientDetailsFMLA.PatientPhoneNumber.toString();
          patientDetailsFMLA.RequesterEmail = patientDetailsFMLA.PEmail.toString();
          patientDetailsFMLA.RequesterAddLine1 = patientDetailsFMLA.PAddLine1.toString();
          patientDetailsFMLA.RequesterAddLine2 = patientDetailsFMLA.PAddLine2.toString();
          patientDetailsFMLA.RequesterCity = patientDetailsFMLA.PCity.toString();
          patientDetailsFMLA.RequesterState = patientDetailsFMLA.PState.toString();
          patientDetailsFMLA.RequesterZipCode = patientDetailsFMLA.PZipCode.toString();
        }
        const patientDetailsModel = {
          "IsPatient": patientDetailsFMLA.IsPatient.toString().toUpperCase(),//IsPatient.toString(),
          "Is_Patient_Minor": patientDetailsFMLA.IsPatientMinor.toString().toUpperCase(),//IsPatientMinor.toString(),
          "AssociatedWithPatient": patientDetailsFMLA.AssociatedWithPatient != "" ? patientDetailsFMLA.AssociatedWithPatient.toString() == "1" ? "Parent/Legal Guardian" : patientDetailsFMLA.AssociatedWithPatient.toString() == "2" ? "Authorized Representative" : patientDetailsFMLA.AssociatedWithPatient.toString() == "3" ? "Third Party (i.e. Insurance/Employer)" : "NA" : "NA",
          "PatientFirstName": patientDetailsFMLA.PFirstName.toString(),
          "PatientLastName": patientDetailsFMLA.PLastName.toString(),
          // "PatientDateOfBirth": patientDetailsFMLA.PDOB != "" ? patientDetailsFMLA.PDOB : null,//"2000-08-13T14:27:35.985Z", //new Date(PDOB).toString(),
          "PatientDateOfBirth": patientDetailsFMLA.PDOB != "" ? dataDate(patientDetailsFMLA.PDOB) : null,
          "PatientEmail": patientDetailsFMLA.PEmail.toString(),
          "PatientAddressLine1": patientDetailsFMLA.PAddLine1.toString(),
          "PatientAddressLine2": patientDetailsFMLA.PAddLine2.toString(),
          "PatientPhoneNumber": patientDetailsFMLA.PatientPhoneNumber.toString(),
          "PatientCity": patientDetailsFMLA.PCity.toString(),
          "PatientState": patientDetailsFMLA.PState.toString(),
          "PatientZipCode": patientDetailsFMLA.PZipCode.toString(),
          "RequesterFName": patientDetailsFMLA.RequesterFName.toString(),
          "RequesterLName": patientDetailsFMLA.RequesterLName.toString(),
          "RequesterPhoneNumber": patientDetailsFMLA.RequesterPhoneNumber.toString(),
          "RequesterEmail": patientDetailsFMLA.RequesterEmail.toString(),
          "RequesterAddressLine1": patientDetailsFMLA.RequesterAddLine1.toString(),
          "RequesterAddressLine2": patientDetailsFMLA.RequesterAddLine2.toString(),
          "RequesterCity": patientDetailsFMLA.RequesterCity.toString(),
          "RequesterState": patientDetailsFMLA.RequesterState.toString(),
          "RequesterZipCode": patientDetailsFMLA.RequesterZipCode.toString(),
          // "Facility_StartDate": patientDetailsFMLA.FacilityStartDate != "" ? patientDetailsFMLA.FacilityStartDate : null,
          "Facility_StartDate": patientDetailsFMLA.FacilityStartDate != "" ? dataDate(patientDetailsFMLA.FacilityStartDate) : null,
          // "Facility_EndDate": patientDetailsFMLA.FacilityEndDate != "" ? patientDetailsFMLA.FacilityEndDate : null,
          "Facility_EndDate": patientDetailsFMLA.FacilityEndDate != "" ? dataDate(patientDetailsFMLA.FacilityEndDate) : null,
          "Facility_Email": patientDetailsFMLA.FacilityEmail.toString(),//form.getFieldValue("FacilityEmail").toString(),
          "FphysicianName": patientDetailsFMLA.FphysicianName.toString(),//form.getFieldValue("FphysicianName").toString(),
          "FacilityName": form.getFieldValue("ffacilityname").toString(),
          "FacilityPhoneNumber": patientDetailsFMLA.FacilityPhoneNumber.toString(),//form.getFieldValue("fphone").toString(),
          "FacilityAddressLine1": form.getFieldValue("faddress1").toString(),
          "FacilityAddressLine2": patientDetailsFMLA.FacilityAddressLine2.toString(),//form.getFieldValue("faddress2").toString(),
          "FacilityCity": form.getFieldValue("fcity").toString(),
          "FacilityState": form.getFieldValue("fstate").toString(),
          "FacilityZipCode": form.getFieldValue("fzipcode").toString(),
          "DiscloseRecordsTo": patientDetailsFMLA.RecipientDiscloseRecordsTo.toString(),
          "MethodOfRelease": patientDetailsFMLA.RecipientMethodOfRelease.toString(),
          "RecipientName": form.getFieldValue("nameorganization").toString(),//patientDetailsFMLA.RecipientName.toString(),
          "RecipientEmail": form.getFieldValue("remail").toString(),//patientDetailsFMLA.RecipientEmail.toString(),
          "RecipientVerifyEmail": patientDetailsFMLA.RecipientVerifyEmail.toString(),
          "RecipientFax": patientDetailsFMLA.RecipientFax.toString(),//form.getFieldValue("faxnumber").toString(),//
          "RecipientPhoneNumber": patientDetailsFMLA.RecipientPhoneNumber.toString() != "" ? patientDetailsFMLA.RecipientPhoneNumber.toString() : form.getFieldValue("phone").toString(),//patientDetailsFMLA.RecipientPhoneNumber.toString(),
          "Authorization_Signature": patientDetailsFMLA.Authorizationsignature,
          "Authorization_Auth1": patientDetailsFMLA.Authorization1,
          "Authorization_Auth2": patientDetailsFMLA.Authorization2,
          "Authorization_Auth3": patientDetailsFMLA.Authorization3,
          "Authorization_Auth4": patientDetailsFMLA.Authorization4,
          "DocumentHIPPAAuthorization": patientDetailsFMLA.DocumentHIPPAAuthorization,
          "DocumentFMLAForm": patientDetailsFMLA.DocumentFMLAForm,
          "DocumentAdditionalDoc": patientDetailsFMLA.DocumentAdditionalDoc,
          "DocumentAdditionalNotes": patientDetailsFMLA.DocumentAdditionalNotes.toString(),
          "Token": sessionStorage.getItem("secrateKey"),
          "Is_FMLA_Req": true,
          "ClientName": sessionStorage.getItem("currentActiveClient")
        }
        

        if (sessionStorage.getItem("secrateKey") != null) {
          let result = await apiservice.postRequest(
            "SavePatientDetails/PatientInformation",
            patientDetailsModel
          );

          if (result.status !== null) {
            if (result == "SUCCESS") {
              setLoading(false);
              navigate("/Thanks");
            }
            else if (result == "Failed") {
              setLoading(false);
              message.error(`Something went wrong, please try again!`);
            }
          }
        }
        else {
          setLoading(false);
          message.error(`Something went wrong, please try again!`);
        }
      })
      .catch((info) => {
        setLoading(false);
      });
  };

  const steps = [
    {
      title: "Patient",
    },
    {
      title: "Requester",
    },
    {
      title: "Facility",
    },
    {
      title: "Recipient",
    },
    {
      title: "Authorization"
    },
    {
      title: "Documents",
    },
  ];

  const getChildData = (value, name) => {
    let res = { ...patientDetailsFMLA, [name]: value }
    setpatientDetails(res);
  }
  const next = () => {
    form
      .validateFields()
      .then(() => {
        setCurrent(patientDetailsFMLA.IsPatient === "yes" && current === 0 ? current + 2 : current + 1);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const prev = () => {
    setCurrent(patientDetailsFMLA.IsPatient === "yes" && current === 2 ? current - 2 : current - 1);
  };
  const onFinish = (values) => {
    navigate("/Thanks");
  };
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  return (

    <Layout className="bg-white">
      <Spin spinning={loading}>
       <CustomHeader />
        <Content className="p-6 pb-0">
          <div className="container mx-auto">
            <Steps
              className={theme}
              type="default"
              labelPlacement={"vertical"}
              current={current}
              items={items}
            />

            {current === 0 && (
              <Form
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step1"
                layout="vertical"
              >
                <PatientInformation getChildData={getChildData} form={form} patientDetailsFMLA={patientDetailsFMLA} />
              </Form>
            )}
            {current === 1 && patientDetailsFMLA.IsPatient === "no" &&
              <Form
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step2"
                layout="vertical"
              >
                <Requester getChildData={getChildData} form={form} />
              </Form>
            }
            {current === 2 &&
              <Form
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step2"
                layout="vertical"
              >
                <Facility patientDetailsFMLA={patientDetailsFMLA} getChildData={getChildData} form={form} />
              </Form>
            }
            {current === 3 &&
              <Form
                {...FormItemLayout}
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step4"
                layout="vertical"
              >
                <Recipient getChildData={getChildData} form={form} patientDetailsFMLA={patientDetailsFMLA} />
              </Form>
            }
            {current === 4 &&
              <Form
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step5"
                layout="vertical"
              >
                <Authorization getChildData={getChildData} form={form} patientDetailsFMLA={patientDetailsFMLA} />
              </Form>
            }

            {current === 5 &&
              <Form
                form={form}
                variant="outlined"
                onFinish={onFinish}
                initialValues={{ remember: true }}
                colon={false}
                name="step6"
                layout="vertical"
              >
                <Document getChildData={getChildData} form={form} patientDetailsFMLA={patientDetailsFMLA} defaultFile={defaultFile} setDefaultFile={setDefaultFile}/>
              </Form>
            }

            <Space className="mt-8 w-full justify-between">
              {current > 0 && (
                <Button
                  type="primary"
                  onClick={() => prev()}
                >
                  Back
                </Button>
              )}
              {current === steps.length - 1 && (
                <Button
                  type="primary"
                  onClick={current === 5 ? onsubmit : next}
                >
                  {current === 5 ? "Submit" : "Next"}
                </Button>
              )}
              {!current && (
                <Link to="/Requirement">
                  <Button
                    type="primary"
                  >
                    Back
                  </Button>
                </Link>
              )}
              {current < steps.length - 1 && (
                <Button
                  type="primary"
                  onClick={() => next()}
                >
                  Next
                </Button>
              )}
            </Space>
            <Footer className="welcome-footer bg-white">
              <img
                className="m-auto"
                src={window.location.origin + "/assets/images/Logo.svg"}
              />
            </Footer>
          </div>
        </Content>
      </Spin>
    </Layout>
  );
};

export default PatientdetailsFMLA;
